import Axios from "axios";
import { GET_SPOT_ID_ENDPOINT } from "../../apiConfig";
import { getDomain } from "../../../Utilities/utils";

/**
 * This function retrieves a goldmine ID and user ID from a given search parameter or a default URL.
 * @param search - The search parameter is a string, is used to check conditions
 * @returns The function `getGoldmineAndUserId` is returning the array in response.
 * Example: `122:5` `(goldmineID:userID)`
 */
export default async function getGoldmineAndUserId(search) {
  try {
    const id =
      search === "" ? "8JTNvV0pFBFDTQEakGZ53A==" : search.split("=")[1];
    const domain = getDomain();
    const response = await Axios.get(`${domain}${GET_SPOT_ID_ENDPOINT}/${id}`);

    console.log("getGoldmineAndUserId (quickQuoteHelper.js)", response.data);
    return response.data;
  } catch (error) {
    console.log("getGoldmineAndUserId (quickQuoteHelper.js) error: ", error);
  }
}
